$ = jQuery = require( 'jquery' );
require( './base' );


//////////////////
// WEBPACK FOOTER
// ./assets/javascripts/common.js
// module id = 0
// module chunks = 0